import './CheckBox.scss';
import CheckboxYes from '../../../images/checkbox-yes.png';
import CheckboxNo from '../../../images/checkbox-no.png';

export const CheckBox = ({ isChecked, onChange, text, link }) => {
  return (
    <div className="check-box">
      {isChecked ? (
        <img src={CheckboxYes} onClick={() => onChange(false)}></img>
      ) : (
        <img src={CheckboxNo} onClick={() => onChange(true)}></img>
      )}
      <div className="text">
        {text}{' '}
        <a href={link} target="_blank" rel="noreferrer">
          Read More
        </a>
      </div>
    </div>
  );
};
